"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Avatar = _interopRequireDefault(require("../../Avatar"));
var _proptypes = _interopRequireDefault(require("./proptypes"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var ListItemAvatar = function ListItemAvatar(props) {
  return /*#__PURE__*/_react["default"].createElement(_Avatar["default"], _extends({
    size: "small"
  }, props));
};
ListItemAvatar.propTypes = process.env.NODE_ENV !== "production" ? _proptypes["default"] : {};
var _default = exports["default"] = ListItemAvatar;